<template>
    <div>
        <b-badge class="mr-2" pill v-for="filtro in pills" :key="filtro.id">
            <span class="mx-2">{{filtro.texto}}:</span>
            <span class="mr-2">{{filtro.valor}}</span>
        </b-badge>
    </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";
export default {
    data : () => ({
        pills : []
    }),
    props : {
        filtro : {
            required : true,
        }
    },
    watch : {
        filtro : {
            handler(){
                this.pills = Object.entries(cloneDeep(this.filtro)).map(el => {
                    let texto = "";
                    switch(el[0]){
                        case "pessoa" :
                            texto = "";
                            break;
                        case "projeto" :
                            texto = "";
                            break;
                        case "status" :
                            texto = "Status";
                            break;
                        case "DataInicio" :
                            texto = "Data inicial";
                            break;
                        case "DataFim" :
                            texto = "Data final";
                            break;
                        case "anoInicio" :
                            texto = "";
                            break;
                        case "anoFinal" :
                            texto = "";
                            break;
                        case "mesInicio" :
                            texto = "";
                            break;
                        case "mesFim" :
                            texto = "";
                            break;
                        case "mesFinal" :
                            texto = "";
                            break;
                        case "projetoLabel" :
                            texto = "Projeto";
                            break;
                        case "pessoaLabel":
                            texto = "Pessoa";
                            break;
                    }

                    let valor = null;
                    if(el[1] != null){
                        switch(el[0]){
                            case "DataInicio" : case "DataFim" :
                                valor = helpers.formatarDataBr(el[1]);
                                break;
                            default:
                                valor = el[1];
                                break;
                        }
                    }
                    return {
                        id : el[0],
                        texto : texto,
                        valor : valor != "" ? valor : null,
                        original : el[1],
                    }
                }).filter(el => el.valor != null && el.texto);
            },
            deep : true,
            immediate : true
        }
    }
}
</script>
<style lang="">
    
</style>